import React from "react";
import Checklist from "../images/checklist.svg";
import Benefit from "../images/benefit.png";

const Benefits = () => {
  const benefitsList = [
    "Kualitas sumber daya manusia yang terseleksi dengan baik",
    "Sistem pelatihan yang terarah",
    "Sistem manajemen administrasi standar",
    "Sistem keamanan terintegrasi",
    "Sistem operasional 24 jam",
    "Tenaga ahli yang kompeten",
    "Laporan berkala kepada customer",
    "Sistem pengawasan dan monitoring lapangan oleh unsur TNI & POLRI",
  ];

  return (
    <section data-aos="zoom-in-down" className="bg-gray-50 py-16 md:py-20">
      <div className="container-app">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Gambar di sebelah kiri */}
          <div className="lg:w-1/2 w-full" data-aos-delay="200">
            <img
              src={Benefit}
              alt="Illustration"
              className="rounded-2xl shadow-card w-full lg:w-3/4 mx-auto lg:mx-0"
            />
          </div>

          {/* Daftar manfaat di sebelah kanan */}
          <div className="lg:w-1/2 w-full" data-aos-delay="400">
            <span className="section-eyebrow block text-center lg:text-left">Kenapa Kami</span>
            <h2 className="section-title text-center lg:text-left mb-8">
              Mengapa Harus Memilih Kami?
            </h2>
            <ul className="space-y-3">
              {benefitsList.map((benefit, index) => (
                <li
                  key={index}
                  className="flex items-start gap-3 rounded-xl bg-white border border-slate-100 shadow-sm px-4 py-3 transition-all duration-200 hover:shadow-card hover:-translate-y-0.5"
                >
                  <img
                    alt=""
                    src={Checklist}
                    className="w-5 h-5 mt-0.5 shrink-0"
                  />
                  <span className="text-slate-700 leading-relaxed">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
